<!--@formatter:off-->
<i18n src="./locale.json"></i18n>
<!--@formatter:on-->

<template lang="pug">

  div

    div.c-auth-page__head
      h1 {{ $t('h1') }}
      h2 {{ $t('h2') }}

    form-enter-password
    router-link.link-btn.forgot-password(:to={'name': 'enter-forgot-code'}) {{ $t('forgot-password') }}
</template>

<script>
import { minLength, numeric, required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';

import formEnterPassword from '../form-enter-password/component';

export default {
  data() {
    return {
      model: {
        phoneCode: this.$store.state.registration.phoneCode,
        phoneNumber: this.$store.state.registration.phoneNumber,
      },
    };
  },

  components: {
    formEnterPassword,
  },

  computed: {
    ...mapGetters('registration', ['phoneCode', 'phoneNumber', 'smsCode', 'smsCodeValid']),
  },

  validations: {
    model: {
      phoneCode: {
        required,
        numeric,
        minLength: minLength(1),
      },
      phoneNumber: {
        required,
        numeric,
        minLength: minLength(10),
      },
    },
  },

  mounted() {
    if (this.smsCodeValid !== true) {
      this.$router.push({ name: 'enter-number' });
    }

    if (this.$v.$invalid) {
      this.$router.push({ name: 'enter-number' });
    }
  },
};
</script>

<style scoped>
.forgot-password {
  margin-top: 16px;
}
</style>
